import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { DateModel } from "../../../businessFoundation/Primitives/DateManage/DateModel";
import { TextField } from "@episerver/ui-framework";

const DateField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, setValue, errors } = props;
    const validationData = property.validationData as DateModel;

    useEffect(() => {
        if (property.value) {
            setValue(`extendedProperties[${index}].value`, property.value.slice(0, 10));
        } else {
            setValue(`extendedProperties[${index}].value`, "");
        }
    }, [property.value]);

    const checkValue = (str: string | null) => {
        if (str) {
            const minValue = parseFloat(validationData.minValue.replace(/-/g, ""));
            const maxValue = parseFloat(validationData.maxValue.replace(/-/g, ""));
            const value = parseFloat(str.replace(/-/g, ""));
            if (value < minValue) {
                return `${property.friendlyName} must not be before ${validationData.minValue}.`;
            } else if (value > maxValue) {
                return `${property.friendlyName} must not be after ${validationData.maxValue}.`;
            } else {
                return "";
            }
        } else if (property.isNullable) {
            return "";
        } else {
            return `${property.friendlyName} is invalid`;
        }
    };

    return (
        <div className="date-field">
            <Controller
                name={`extendedProperties[${index}].value`}
                control={control}
                rules={{
                    required: {
                        value: !property.isNullable,
                        message: `${property.friendlyName} is required`,
                    },
                    validate: {
                        [`properties[${index}].value`]: (v) => {
                            const result = checkValue(v);
                            if (result) {
                                return result;
                            } else {
                                return true;
                            }
                        },
                    },
                }}
                render={({ field: { value, onChange } }) => (
                    <TextField
                        id={`extendedProperties[${index}].value`}
                        type="date"
                        outlined
                        label={property.friendlyName}
                        helperText={
                            errors.extendedProperties
                                ? errors.extendedProperties[index]?.value?.message ?? property.description
                                : property.description
                        }
                        invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                        value={value}
                        onChange={onChange}
                    />
                )}
            />
        </div>
    );
};

export default DateField;
